<template>
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="preguntas">              
        <div class="row">
          <div class="col-12 col-md-6 mb-3" v-for="(pregunta, ix) in data_preguntas" :key="`${ix}_${pregunta.pregunta_id}`">
            <div class="pregunta-container">
              <div>
                <p class="pregunta-pregunta">{{ pregunta.pregunta }}</p>
              </div>
              <BarChart
                v-if="!pregunta.type"
                class="pregunta-respuestas"
                :lista_encuestas="answer(pregunta.id)"
                :pregunta-parent="pregunta"
              />
              <BarStacked
                v-if="pregunta.type==`stacked`"
                class="pregunta-respuestas"
                :lista_encuestas="answer(pregunta.id)"
                :pregunta-parent="pregunta"
              />
              <barChartFaces
              v-if="pregunta.type=='barChartFaces'"
              class="pregunta-respuestas"
              :partyData="partyData(pregunta.id)"
              :noParty="noPartyData(pregunta.id)"
              :data="answer(pregunta.id)"
              :pregunta-parent="pregunta"
            />   
              <barVerticalChart
                v-if="pregunta.type=='verticalChart'"
                class="pregunta-respuestas"
                :data="partyData(pregunta.id)"
                :noParty="noPartyData(pregunta.id)"
                :pregunta-parent="pregunta"
              />
              
              <barChartGroup
                v-if="pregunta.type=='barChartGroup'"
                class="pregunta-respuestas"
                :data="answer(pregunta.id)"
                :pregunta-parent="pregunta"
              />

              <barChartStackedGroup
                v-if="pregunta.type=='barChartStackedGroup'"
                class="pregunta-respuestas"
                :data="answer(pregunta.id)"
                :pregunta-parent="pregunta"
              />
            </div>            
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { filter, orderBy } from 'lodash'
import BarChart from '@/components/BarChart'
import BarStacked from '@/components/BarStacked'
import barChartFaces from '@/components/barChartFaces'
import barVerticalChart from '@/components/barVerticalChart'
import barChartGroup from '@/components/barChartGroup'
import barChartStackedGroup from '@/components/barChartStackedGroup'

export default  {
  name: 'CategoryPreguntas',
  props: {
    data_preguntas: {
      type: [Array, Object]
    }
  },
  components: {
    BarChart,
    BarStacked,
    barChartFaces,
    barVerticalChart,
    barChartGroup,
    barChartStackedGroup
  }, 
  computed: {
    ...mapState({
      data_encuestas: state => state.encuesta.data_encuestas,
    })
  },
  methods: {
      answer(id) {
        return orderBy(filter(this.data_encuestas,["question_id",id]), ['date_one'], ['desc'])
      },
      partyData(id) {
        let filteredData = filter(this.data_encuestas, (item) => {
          if(item.question_id == id && item.partido != "") {
            return item
          }
        })
        return orderBy(filteredData, ['date_one'], ['desc'])
      },
      noPartyData(id) {
        let filteredData = filter(this.data_encuestas, (item) => {
          if(item.question_id == id && item.partido == "") {
            return item
          }
        })
        return orderBy(filteredData, ['date_one'], ['desc'])
      }
    }
  }

</script>
